import {format} from 'date-fns'
import {curry, get} from 'lodash/fp'

export const getOr = curry(function(paths, data) {
  return paths.reduce((result, path) => {
    if(result) return result
    return  get(path, data)
  }, undefined)
})

export const renderIf = curry(function(test, component) {
  if(test) return component
  return undefined
})

export const renderIfGet = curry(function(data, test, component) {
  if(get(data, test)) return component
  return undefined
})

export const humanizeDate = function (date) {
  if (date) {
    const d = new Date(
      Number(date.toString().substring(0, 4)),
      Number(date.toString().substring(4, 6)) - 1,
      Number(date.toString().substring(6, 8))
    )
    if (date.toString().substring(4, 6) === '05') { // Are we in May?
      return format(d, 'MMM D, YYYY')
    } else {
      return format(d, 'MMM. D, YYYY')
    }
  } else {
    return ''
  }
}

export const rotateArray = function (arr, order) {
  if (isNaN(order) || order < 0) {
    throw new Error('provide valid order')
  }
  if (arr.length === 0) {
    throw new Error('provide valid array')
  }
  let result = arr.slice(0)
  for (let i = 0; i < order; i++) {
    for (let j = result.length - 1; j > 0; j--) {
      const t = result[j]
      result[j] = result[j - 1]
      result[j - 1] = t
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/lib/util.js